import React from "react";
import { connect } from "react-redux";
import {getFundFiles,addFileToFund, deleteFundFile} from 'store/state/fund';
import AttachmentsDrawer from 'components/Global/Attachments/AttachmentsDrawer';
import _ from 'lodash';

class FundAttachments extends React.Component {

  componentDidUpdate(prevProps, prevState){
    const { fundId,isOpen} = this.props;
    const {isOpen: prevIsOpen} = prevProps;
    if(isOpen !== prevIsOpen && isOpen){
      this.props.getFundFiles({
        modelName: 'fund',
        modelId:fundId,
        subKey: fundId
      })
    }
  }

  handleRemoveFile = (fileId) => {
    const {fundId} = this.props;
    this.props.deleteFundFile({
      fileId: fileId, 
      shouldUpdateAfter:true, 
      modelName: 'fund',
      modelId: fundId,
      subKey:fundId });
  }

  render() {
    const {isOpen, closeAttachments, fundFiles, fundId,addFileToFund, isLoading} = this.props;    
    const specificFundFiles = fundFiles[fundId] || [];

    return (
      <React.Fragment>
        <AttachmentsDrawer
        internalID = {"ForFund"+fundId}
          drawerWidth={600}
          addFile={(file) => addFileToFund('fund', fundId, file)}
          isOpen={isOpen}
          isLoading={isLoading}
          closeDrawer={closeAttachments}
          files={specificFundFiles} 
          handleRemove={this.handleRemoveFile}/>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ fund, loading}) => ({
  fundFiles: fund.fundFiles,
  isLoading: loading.fund_file_upload
});

export default connect(
  mapStateToProps,
  {   
    getFundFiles,
    addFileToFund,
    deleteFundFile
  }
)(FundAttachments);

